export const locationQueryKeys = {
	duplicateReviews: {
		all: ["duplicate-reviews"] as const,
		list: (status: string) => ["duplicate-reviews", "list", status] as const,
	},
	imageReviews: {
		all: ["image-reviews"] as const,
		list: (status: string) => ["image-reviews", "list", status] as const,
	},
	locationReports: {
		all: ["location-reports"] as const,
		list: (status: string) => ["location-reports", "list", status] as const,
		summary: (status: string) => ["location-reports", "summary", status] as const,
	},
	locationScreens: {
		all: ["location-screens"] as const,
		list: (resolution: string) => ["location-screens", "list", resolution] as const,
	},
	locations: {
		all: ["locations"] as const,
		courtDetail: (locationId: string, courtId: string) =>
			["locations", locationId, "courts", courtId] as const,
		courts: (locationId: string) => ["locations", locationId, "courts"] as const,
		detail: (id: string) => ["locations", id] as const,
		list: (params: object = {}) => ["locations", "list", params] as const,
	},
} as const;
